import React from "react"
import DateTimeField from "components/Common/DateTimeField"
import Select from "react-select"
import { capitalize } from "lodash"
import { LEAD_SORT_OPTIONS } from "./listQuery"
import { withFloatingSurface } from "components/Common/selectSurface"

const statusOptions = [
  { label: "Pending", value: "pending" },
  { label: "Closed", value: "closed" },
]

const FilterList = ({
  filters, onChange, locations, settings, advancedFilters, sortBy, onSort,
  locationsLoading, dateError,
}) => {
  const locationOptions = locations.map(location => ({
    label: location.name || [location.city, location.country].filter(Boolean).join(", "),
    value: `${location.city ?? "null"}, ${location.country}`,
  }))
  const sports = [...new Set([...(settings?.activeSports || []), filters.sportType]
    .filter(sport => sport && sport !== "unspecified"))]
  const sportOptions = [
    ...sports.map(sport => ({ label: capitalize(sport), value: sport })),
    { label: "Not specified", value: "unspecified" },
  ]
  const selectField = (key, label, options) => (
    <div className="club-filter-field">
      <label htmlFor={`lead-${key}`}>{label}</label>
      <Select styles={withFloatingSurface()} inputId={`lead-${key}`} instanceId={`lead-${key}`}
        name={key} options={options} placeholder="All" isClearable
        classNamePrefix="club-filter-select"
        isLoading={key === "location" && locationsLoading}
        value={options.find(option => option.value === filters[key]) ||
          (filters[key] ? { value: filters[key], label: filters[key].replace(/^null, /, "") } : null)}
        onChange={option => onChange({ [key]: option?.value || "" })}
      />
    </div>
  )
  return (
    <>
      <div className="club-filters-primary">
        {selectField("location", "Location", locationOptions)}
        {selectField("sportType", "Sport", sportOptions)}
        {selectField("status", "Status", statusOptions)}
        <div className="club-filter-field">
          <label htmlFor="lead-sort">Sort leads</label>
          <select id="lead-sort" className="custom-select" value={sortBy}
            onChange={event => onSort(event.target.value)}>
            {LEAD_SORT_OPTIONS.map(option => <option key={option.value} value={option.value}>{option.label}</option>)}
          </select>
        </div>
      </div>
      {advancedFilters && (
        <div id="lead-date-filters" className="club-filters-secondary">
          {[["fromDate", "Created from"], ["toDate", "Created to"]].map(([key, label]) => (
            <div className="club-filter-field" key={key}>
              <label htmlFor={`lead-${key}`}>{label}</label>
              <DateTimeField id={`lead-${key}`} name={key} mode="date"
                {...(key === "fromDate" ? { rangeEnd: filters.toDate || "" } : { rangeStart: filters.fromDate || "" })}
                value={filters[key] || ""} aria-invalid={Boolean(dateError)}
                aria-describedby={dateError ? "lead-date-error" : "lead-timezone"}
                onChange={event => onChange({ [key]: event.target.value })} />
            </div>
          ))}
        </div>
      )}
    </>
  )
}

export default FilterList
